import { Component } from '@angular/core';

@Component({
  selector: 'op-cashbook',
  templateUrl: './cashbook.component.html',
})
export class CashbookComponent {
}
